module.exports = {"210702001":"天安街道","210702002":"石油街道","210702003":"北街街道","210702004":"敬业街道","210702005":"保安街道","210702006":"南街街道","210702007":"饶阳街道","210702008":"站前街道","210702009":"士英街道","210702010":"钟屯街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210702.json
// module id = 551
// module chunks = 0